import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { usersApi } from '../api/users.api'
import { usersKeys } from './query-keys'

export type { IdmAccMappingRecord } from '../api/users.api'

export const useIdmAccMappings = () =>
	useQuery({
		queryKey: usersKeys.idmAccMappings.list(),
		queryFn: usersApi.listIdmAccMappings,
	})

export const useCreateIdmAccMapping = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: usersApi.createIdmAccMapping,
		onSuccess: () => void qc.invalidateQueries({ queryKey: usersKeys.idmAccMappings.list() }),
	})
}

export const useUpdateIdmAccMapping = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: usersApi.updateIdmAccMapping,
		onSuccess: () => void qc.invalidateQueries({ queryKey: usersKeys.idmAccMappings.list() }),
	})
}

export const useDeleteIdmAccMapping = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: usersApi.deleteIdmAccMapping,
		onSuccess: () => void qc.invalidateQueries({ queryKey: usersKeys.idmAccMappings.list() }),
	})
}
